import axios from 'axios'
import { organizationUrl, getHeader } from '@/config'

const state = {
  organizationList: []
}

const mutations = {
  SET_ORGANIZATION_LIST (state, obj) {
    state.organizationList = obj
  }
}

const actions = {
  getOrganizationList: ({ commit }) => {
    axios.get(organizationUrl, { headers: getHeader() })
      .then(response => {
        commit('SET_ORGANIZATION_LIST', response.data.data)
      })
  }
}

export default {
  state, mutations, actions
}
